"use client";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";
import Face from "@/public/icon/face.svg";
import Insta from "@/public/icon/insta.svg";
import Tiktok from "@/public/icon/tiktok.svg";
import Youtube from "@/public/icon/youtube.svg";
import Wp from "@/public/icon/whatsapp.svg";
import Phone from "@/public/icon/phone.svg";
import Logo from "@/public/icon/logo.svg";
import Pin from "@/public/icon/pin.svg";
import Cart from "@/public/icon/cart.svg";
import User from "@/public/icon/user.svg";
import Heart from "@/public/icon/heart.svg";
import Search from "@/public/icon/search.svg";
import Down from "@/public/icon/down.svg";
import Close from "@/public/icon/close.svg";
import Left from "@/public/icon/arrowLeft.svg";
import Image from "next/image";
import Product from "@/public/images/product.png";
import Rating from "@/public/icon/rating.svg";
import Menu from "@/public/icon/menu.svg";
import ArrowRight from "@/public//icon/arrowRight.svg";
import http from "@/libs/config/http";
import Lang from "../Lang/Lang";
import { useRouter, usePathname } from "next/navigation";
import { useSession } from "@/hooks/useSession";
import baseQueries from "@/libs/provideBaseQueriesOnFilterUrl";
import Socials from "../Socials/Socials";
import CartCard from "../CartCard/CartCard";
import CartEmpty from "@/public/icon/cartEm.svg";
import { useCheckout } from "@/hooks/useCheckout";
const Header = ({
  setting,
  campaigns,
  special_brand_menus,
  menu_brands,
  headerMenu,
  gender,
  langData,
  t,
  initialItems,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const toggleSearch = () => setSearchOpen(false);
  const [isLoading, setIsLoading] = useState(false);
  const { session } = useSession();

  const { cartList, removeFromCart, cartTotal } = useCheckout();

  const handleBlur = (event) => {
    if (!containerRef.current.contains(event.relatedTarget)) {
      setIsOpen(false);
      setSearchOpen(false);
    }
  };

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const keyword = searchQuery.trim();
    if (!keyword) {
      setSearchResults([]);
      setIsLoading(false);
      return;
    }

    const controller = new AbortController();
    const delayDebounce = setTimeout(async () => {
      setIsLoading(true);
      try {
        const response = await http(
          `products/product/search?keyword=${encodeURIComponent(keyword)}`,
          {
            signal: controller.signal,
          }
        );
        setSearchResults(response?.data || []);
      } catch (error) {
        if (error?.name !== "AbortError") {
          console.log("Error fetching search results:", error);
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    }, 1300);

    return () => {
      clearTimeout(delayDebounce);
      controller.abort();
    };
  }, [searchQuery]);
  const router = useRouter();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim().length >= 1) {
      router.push(`/products?keyword=${searchQuery}&${baseQueries.toString()}`);
      setSearchOpen(false);
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (searchQuery.length >= 3 && searchResults.length > 0) {
      setSearchOpen(true);
      setIsOpen(true);
    } else {
      setSearchOpen(false);
      setIsOpen(false);
    }
  }, [searchQuery, searchResults]);
  const [searchPopupMobile, setSearchPopupMobile] = useState(false);
  const handleSearch = () => {
    setSearchPopupMobile(true);
    setIsOpen(false);
  };
  const [cartPopup, setCartPopup] = useState(false);
  const handleCart = () => {
    setCartPopup(!cartPopup);
    setMenuOpen(!menuOpen);
  };

  const handleItemDelete = async (product_id, volume_id) => {
    await removeFromCart({
      product_id,
      volume_id,
      succesMessage: t["success.message"],
      errorMessage: t["error.title"],
    });
  };
  const pathname = usePathname();

  const supportedLocales = ["az", "en", "ru"];
  const isHome =
    supportedLocales.some((locale) => pathname === `/${locale}`) ||
    pathname === "/";
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const nextIsScrolled = window.scrollY > 100;
        setIsScrolled((prev) => (prev === nextIsScrolled ? prev : nextIsScrolled));
        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleClose = () => {
    setIsOpen(false);
    setSearchOpen(false);
    setCartPopup(false);
    setSearchPopupMobile(false);
  };
  return (
    <header>
      <div className={`cartPopup ${cartPopup ? "cartActive" : ""}`}>
        <div className="cartPopupLayer"></div>
        <div className="cartPopupInner">
          <div className="cartPopupTop">
            <span>{t["buttons.basket"]}</span>
            <Close className="closeClass" onClick={handleClose} />
          </div>
          <div className="cartList">
            {cartList?.length > 0 ? (
              cartList.map((item) => (
                <CartCard
                  key={`${item?.product?.id}-${item?.volume?.id}`}
                  item={item}
                  onDelete={handleItemDelete}
                  t={t}
                />
              ))
            ) : (
              <div className="emptyCart">
                <span>{t["cart.empty"]}</span>

                <CartEmpty />
              </div>
            )}
          </div>
          <div className="cartBottom">
            {cartList?.length > 0 ? (
              <p>
                {t["table.header.total_price"]}
                {cartTotal?.total_price === cartTotal?.subtotal ? (
                  <strong>{cartTotal?.total_price + "₼"}</strong>
                ) : (
                  <span>
                    {cartTotal?.subtotal + "₼"}
                    <strong className="discount">
                      {cartTotal?.total_price} ₼
                    </strong>
                  </span>
                )}
              </p>
            ) : null}
            <div className="buttons">
              <Link href="/products" onClick={handleClose}>
                {t["cart.back_to_shop"]}
              </Link>
              {cartList?.length > 0 ? (
                <Link
                  href="/checkout"
                  className="blackButton"
                  onClick={handleClose}
                >
                  {t["buttons.order"]}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`searchPopup ${searchPopupMobile ? "searchuActive" : ""}`}
      >
        <div className="mobileMenuInner">
          <div className="container">
            <div className="mobilebTop">
              <form action="" onSubmit={handleSearchSubmit}>
                <input
                  type="text"
                  placeholder={t["input.search"]}
                  value={searchQuery}
                  onChange={handleSearchInput}
                />
                <button type="button">
                  <Search />
                </button>
              </form>
              <div
                className="xButton"
                onClick={() => {
                  setSearchPopupMobile(false);
                  setIsOpen(false);
                }}
              >
                <Close />
              </div>
            </div>
            <div className="searchListParent">
              <span>{t["search.result.text"]}</span>
              <div className="searchListMob">
                {searchResults?.slice(0, 4).map((item) => (
                  <Link
                    key={item.id}
                    href={`/products/${item.alias}?id=${item.id}`}
                    className="searhCard"
                    onClick={handleClose}
                  >
                    <div className="orderRightCard">
                      <div className="img">
                        <Image
                          src={item?.title_image?.slider}
                          alt="img"
                          width={200}
                          height={200}
                        />
                      </div>
                      <div className="orderRightCardDetail">
                        <h6>{item.title}</h6>
                        <div className="price">
                          <p>
                            {/* Minimum qiymət hissəsi */}
                            {item.min_price_sale &&
                            item.min_price_sale !== 0 &&
                            item.min_price_sale !== item.min_price
                              ? item.min_price_sale + "₼"
                              : item.min_price + "₼"}

                            {/* Maksimum qiymət hissəsi */}
                            {item.max_price && item.max_price !== 0
                              ? item.max_sale_price &&
                                item.max_sale_price !== 0 &&
                                item.max_sale_price !== item.max_price
                                ? " - " + item.max_sale_price + "₼"
                                : " - " + item.max_price + "₼"
                              : ""}
                          </p>

                          {/* Köhnə qiymətin (xətt çəkilmiş) göstərilməsi */}
                          {(item.min_price_sale &&
                            item.min_price_sale !== 0 &&
                            item.min_price_sale !== item.min_price) ||
                          (item.max_sale_price &&
                            item.max_sale_price !== 0 &&
                            item.max_sale_price !== item.max_price) ? (
                            <span
                              style={{
                                textDecoration: "line-through",
                                marginLeft: "8px",
                              }}
                            >
                              {item.min_price}₼
                              {item.max_price && item.max_price !== 0
                                ? " - " + item.max_price + "₼"
                                : ""}
                            </span>
                          ) : null}
                        </div>

                        <div className="rating">
                          <Rating />({item.rating})
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}

                <Link
                  href={`/products?keyword=${searchQuery}&${baseQueries.toString()}`}
                  className="searchListLink"
                  onClick={handleClose}
                >
                  {t["frontend.see_all_products"]}
                  <ArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`mobileMenu ${menuOpen ? "menuActive" : ""}`}>
        <div className="mobileMenuInner">
          <div className="mobileMenuTop">
            <div className="xButton" onClick={toggleMenu}>
              <Left />
            </div>
            <Link href="/" className="logo" onClick={toggleMenu}>
              <Logo />
            </Link>
            <Lang onClick={toggleMenu} />
          </div>
          <div className="accountBar">
            <button onClick={handleCart}>
              <Cart />
              <span>{cartList.length}</span>
              <p>{t["buttons.basket"]}</p>
            </button>

            {!session ? null : (
              <Link href="/account/fav" onClick={toggleMenu}>
                <Heart />
                <p>{t["pages.favorites.title"]}</p>
              </Link>
            )}
            {!session ? null : (
              <Link href="/account/profile" onClick={toggleMenu}>
                <User />
                <p>{t["pages.personal_info.title"]}</p>
              </Link>
            )}
            {session ? null : (
              <Link href="/auth/login" onClick={toggleMenu}>
                <User />
                <p>{t["buttons_login"]}</p>
              </Link>
            )}
          </div>
          <div className="headerTopLeft">
            <Link href="/about" onClick={toggleMenu}>
              İydə perfumery
            </Link>
            <Link href="/news" onClick={toggleMenu}>
              {t["title.blog"]}
            </Link>
            <Link href="/brands" onClick={toggleMenu}>
              {t["title.brands"]}
            </Link>
            <Link href="/support/contact" onClick={toggleMenu}>
              {t["title.support"]}
            </Link>
          </div>
          <div className="headerMobile">
            {menu_brands.map((item, index) => (
              <div key={index}>
                <span onClick={() => handleClick(index)}>
                  <Link
                    href={`${item.alias}&${baseQueries.toString()}`}
                    onClick={toggleMenu}
                  >
                    {item.title}
                  </Link>
                  {item?.sub_menu ? (
                    <Down className={activeIndex === index ? "active" : ""} />
                  ) : null}
                </span>
                <ul className={activeIndex === index ? "active" : ""}>
                  {item?.sub_menu?.map((sub, index) => (
                    <li key={index}>
                      <Link
                        href={`${sub.alias}&${baseQueries.toString()}`}
                        onClick={toggleMenu}
                      >
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="menuBottom">
            <div className="menuBottomSocials">
              <Link href="/stores/azadliq-branch" className="storesLink">
                <Pin />
                <span>{t["sidebar.stores"]}</span>
              </Link>
              <Socials setting={setting} />
            </div>
            <div className="menuBottomLinks">
              <Link href={setting.wp_link} target="_blank" className="whatsapp">
                <Wp />
                Whatsapp
              </Link>
              <Link href={`tel:${setting.number}`} className="phoneButton">
                <Phone />
                <span>{setting.number}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {isOpen && <div className="layer"></div>}

      <div className="container">
        <div className="headerTop">
          <div className="headerTopLeft">
            <Link href="/about">İydə perfumery</Link>
            <Link href="/news">{t["title.blog"]}</Link>
            <Link href="/brands">{t["title.brands"]}</Link>
            <Link href="/support/contact">{t["title.support"]}</Link>
          </div>
          <div className="headerTopRight">
            <div className="socials">
              <Link href={setting.facebook} target="_blank">
                <Face />
              </Link>
              <Link href={setting.instagram} target="_blank">
                <Insta />
              </Link>
              <Link href={setting.tiktok} target="_blank">
                <Tiktok />
              </Link>
              <Link href={setting.youtube} target="_blank">
                <Youtube />
              </Link>
            </div>
            <div className="headerTopRightSide">
              <Link href={setting.wp_link} target="_blank" className="whatsapp">
                <Wp />
                Whatsapp
              </Link>
              <Link href={`tel:${setting.number}`} className="phoneButton">
                <Phone />
                <span> {setting.number}</span>
              </Link>
              <Lang />
            </div>
          </div>
        </div>
        <div className={`headerMiddleScroll ${isScrolled ? "scrolled" : ""}`}>
          <div className="headerMiddle">
            <div className="searchButton" onClick={handleSearch}>
              <Search />
            </div>
            {isHome ? (
              <div className="logo">
                <Logo />
              </div>
            ) : (
              <Link href="/" className="logo">
                <Logo />
              </Link>
            )}
            <div className="menuButton" onClick={toggleMenu}>
              <Menu />
            </div>
            <div
              className="searchInput"
              ref={containerRef}
              // onFocus={handleFocus}
              onBlur={handleBlur}
              tabIndex={-1}
            >
              <form action="" onSubmit={handleSearchSubmit}>
                <input
                  type="text"
                  placeholder={t["input.search"]}
                  value={searchQuery}
                  // onChange={handleSearchInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchQuery(value);
                  }}
                />
                <button type="submit">
                  <Search />
                  {t["input.search"]}
                </button>
              </form>
              {searchOpen ? (
                <>
                  <div className="search-result">
                    {isLoading ? (
                      <div className="searchLoading">
                        {t["site_content.loading"]}...
                      </div>
                    ) : searchResults.length > 0 ? (
                      searchResults?.slice(0, 3).map((item) => (
                        <Link
                          key={item.id}
                          href={`/products/${item.alias}?id=${item.id}`}
                          className="searhCard"
                          onClick={handleClose}
                        >
                          <div className="orderRightCard">
                            <div className="img">
                              <Image
                                src={item.title_image.slider || undefined}
                                alt={item.title}
                                width={100}
                                height={100}
                              />
                            </div>
                            <div className="orderRightCardDetail">
                              <h6>{item.title}</h6>
                              <div className="price">
                                <p>
                                  {/* Minimum qiymət */}
                                  {item.min_price_sale &&
                                  item.min_price_sale !== 0 &&
                                  item.min_price_sale !== item.min_price
                                    ? item.min_price_sale + "₼"
                                    : item.min_price + "₼"}

                                  {/* Maksimum qiymət */}
                                  {item.max_price && item.max_price !== 0
                                    ? item.max_sale_price &&
                                      item.max_sale_price !== 0 &&
                                      item.max_sale_price !== item.max_price
                                      ? " - " + item.max_sale_price + "₼"
                                      : " - " + item.max_price + "₼"
                                    : ""}
                                </p>

                                {/* Əgər hər hansı tərəfdə endirim varsa, köhnə qiymət xəttlə göstərilir */}
                                {(item.min_price_sale &&
                                  item.min_price_sale !== 0 &&
                                  item.min_price_sale !== item.min_price) ||
                                (item.max_sale_price &&
                                  item.max_sale_price !== 0 &&
                                  item.max_sale_price !== item.max_price) ? (
                                  <span
                                    style={{
                                      textDecoration: "line-through",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    {item.min_price}₼
                                    {item.max_price && item.max_price !== 0
                                      ? " - " + item.max_price + "₼"
                                      : ""}
                                  </span>
                                ) : null}
                              </div>

                              <div className="rating">
                                <Rating />({item.rating || "0"})
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <div className="searchLoading">
                        {t["error.not_found_title"]}
                      </div>
                    )}
                    <Link
                      href={`/products?keyword=${searchQuery}&${baseQueries.toString()}`}
                      className="searchListLink"
                      onClick={handleClose}
                    >
                      {t["frontend.see_all_products"]}
                      <ArrowRight />
                    </Link>
                  </div>
                </>
              ) : null}
            </div>
            <Link href="/stores/azadliq-branch" className="storesLink">
              <Pin />
              <span>{t["sidebar.stores"]}</span>
            </Link>
            <div className="accountBar">
              <button onClick={handleCart}>
                <Cart />
                <span>{cartList.length}</span>
                <p>{t["buttons.basket"]}</p>
              </button>
              {!session ? null : (
                <Link href="/account/fav">
                  <Heart />
                  <p>{t["pages.favorites.title"]}</p>
                </Link>
              )}
              {!session ? null : (
                <Link href="/account/profile">
                  <User />
                  <p>{t["pages.personal_info.title"]}</p>
                </Link>
              )}
              {session ? null : (
                <Link href="/auth/login">
                  <User />
                  <p>{t["buttons_login"]}</p>
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="headerBottom">
          <ul>
            <li>
              <Link href="/specials">
                {t["title.menu.specialCollection"]} <Down />
              </Link>
              <ul>
                {special_brand_menus?.map((item) => (
                  <li key={item.id}>
                    <Link href={`${item.alias}&${baseQueries.toString()}`}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            {menu_brands?.map((item, index) => (
              <li key={index}>
                <Link href={`${item.alias}&${baseQueries.toString()}`}>
                  {item.title}
                  {item?.sub_menu == null ? null : <Down />}
                </Link>

                {item?.sub_menu == null ? null : (
                  <ul>
                    {item?.sub_menu?.map((sub, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          href={
                            index === 1 || index === 2
                              ? `${sub.alias}?id=${sub.id}` // 3-cü menyu üçün fərqli link
                              : `${sub.alias}&${baseQueries.toString()}` // qalanları category yönləndirir
                          }
                        >
                          {sub.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
